import {
  Box,
  Button,
  Grid,
  IconButton,
  Modal,
  TextField,
  Typography,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import CancelIcon from "@mui/icons-material/Close";
import { useEffect, useState } from "react";
import { useFormik } from "formik";
import { array, number, object } from "yup";
import useAxiosPrivate from "contexts/interceptors/axios";
import SelectSubject from "components/smea/Textfields/SelectSubject";

const style = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  position: "absolute",
  backgroundColor: "#e9e9e9",
  // background:
  //   "linear-gradient(40deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9))",
  //   border: "solid 2px #46e3be",
  boxShadow: "3px 2px 20px 3px rgba(0, 0, 0, 0.3)",
  borderRadius: "10px",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  p: 2,
  overflow: "auto",
  "@media (min-width: 10px)": {
    height: "90vh",
    width: "85vw",
  },

  "@media (min-width: 480px)": {
    height: "85vh",
    width: "80vw",
  },

  "@media (min-width: 640px)": {
    height: "75vh",
    width: "70vw",
  },

  "@media (min-width: 768px)": {
    height: "75vh",
    width: "70vw",
  },

  "@media (min-width: 1024px)": {
    height: "80vh",
    width: "70vw",
  },

  "@media (min-width: 1082px)": {
    height: "80vh",
    width: "65vw",
  },
};

export default function AddKSASubjectModal({
  open,
  handleClose,
  updateTableFunction,
}) {
  const axiosPrivate = useAxiosPrivate();
  const [disabled, setDisabled] = useState(false);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const formik = useFormik({
    initialValues: { ksa: null, gradeLevel: "", subjects: [] },

    validationSchema: object().shape({
      ksa: number().required("Required"),
      gradeLevel: number().required("Required"),
      subjects: array().required("Required"),
    }),

    onSubmit: () => {
      setLoading(true);
      setError("");

      axiosPrivate
        .post(`/ksa/addKSASubjects`, formik.values)
        .then((res) => res.data)
        .then(() => {
          // eslint-disable-next-line no-alert
          alert("KSA Subjects added Successfully");
          formik.resetForm();
          handleClose();
          updateTableFunction();
        })
        .catch((err) => {
          setError(err?.message);
        })
        .finally(() => {
          setLoading(false);
        });
    },
  });

  useEffect(() => {
    if (!formik.values.gradeLevel) {
      setDisabled(true);
    } else {
      setDisabled(false);
    }
  }, [formik.values]);

  useEffect(() => {
    if (formik.values) {
      const areAllValuesFilled = Object.values(formik.values).every((value) => {
        if (value) {
          return true;
        }
        if (Array.isArray(value) && value.length === 0) {
          return true;
        }
        return false;
      });

      setDisabled(areAllValuesFilled);
    }
  }, [formik.values]);

  return (
    <Modal
      open={open}
      onClose={() => {
        handleClose();
        // formik.resetForm();
        // setError("");
      }}
    >
      <Box
        variant="form"
        component="form"
        onSubmit={formik.handleSubmit}
        autoComplete="off"
        sx={style}
      >
        <Box
          sx={{
            position: "absolute",
            right: 20,
            cursor: "pointer",
            zIndex: 100,
          }}
        >
          <IconButton onClick={handleClose} sx={{ p: 0 }}>
            <CancelIcon />
          </IconButton>
        </Box>
        <Box>
          <Box
            sx={{
              backgroundColor: "#2e3887",
              borderRadius: "10px",
              width: "70%",
              p: 2,
              mb: 2,
            }}
          >
            <Typography
              sx={{ ml: 4, fontSize: 25, fontWeight: "bold", color: "#fff" }}
            >
              ADD KSA SUBJECTS
            </Typography>
          </Box>
          {error}
          <Box
            sx={{
              backgroundColor: "rgba(255, 255, 255, 1)",
              boxShadow: "8px 8px 15px 3px rgba(0, 0, 0, 0.3)",
              borderRadius: "10px",
              p: 4,
              mx: 4,
            }}
          >
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <TextField
                  name="ksa"
                  label="KSA No"
                  size="small"
                  type="number"
                  disabled={loading}
                  value={formik.values.ksa}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBLur}
                  error={formik.touched.ksa && Boolean(formik.errors.ksa)}
                  helperText={formik.touched.ksa && formik.errors.ksa}
                  variant="outlined"
                  sx={{ pr: 5 }}
                  fullWidth
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  name="gradeLevel"
                  label="Grade Level"
                  size="small"
                  type="number"
                  disabled={loading}
                  value={formik.values.gradeLevel}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBLur}
                  error={
                    formik.touched.gradeLevel &&
                    Boolean(formik.errors.gradeLevel)
                  }
                  helperText={
                    formik.touched.gradeLevel && formik.errors.gradeLevel
                  }
                  variant="outlined"
                  sx={{ pr: 5 }}
                  fullWidth
                />
              </Grid>
              <Grid item xs={6}>
                <SelectSubject
                  placeholder="Select a Subject"
                  // label="Select a Subject"
                  name="subject"
                  // disabled={loading}
                  value={formik.values.subjects}
                  onChange={(fieldName, selectedValue) => {
                    formik?.setFieldValue("subjects", selectedValue);
                  }}
                  sx={{
                    width: "100%",
                    pr: 5,
                    "&:hover": {
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "black !important",
                      },
                    },
                  }}
                />
              </Grid>
            </Grid>
          </Box>
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "end",
            alignItems: "center",
            p: 2,
            zIndex: 10,
          }}
        >
          <Button
            disabled={!disabled}
            type="submit"
            sx={{
              display: "flex",
              alignItems: "center",
              backgroundColor: !disabled ? "lightgray" : "#2e3887",
              color: "#fff",
              py: 1,
              width: "10vw",
              minWidth: "100px",
              "&:hover": {
                border: "solid 1px gray",
                backgroundColor: "lightgray",
                color: "#2b2b2b",
                fontWeight: "bold",
              },
            }}
          >
            <AddIcon
              sx={{
                mr: 1,
                color: "#fff",
              }}
            />
            Add
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}
